import * as Yup from 'yup';

export const PreAuthModalValidationSchema = Yup.object().shape({
  cardholderName: Yup.string().when('processor', {
    is: 'payroc',
    then: (schema) => schema,
    otherwise: (schema) =>
      schema
        .required('Cardholder name is required')
        .test(
          'has-full-name',
          'Cardholder name is required. Please enter both first and last name',
          (value) => {
            if (!value) return false;
            const trimmed = value.trim();
            const parts = trimmed.split(/\s+/);
            return parts.length >= 2 && parts.every((part) => part.length > 0);
          }
        )
  }),
  signature: Yup.string().required('Signature is required'),
  address_ln_1: Yup.string().required('Address is required'),
  city: Yup.string().required('City is required'),
  state: Yup.string().required('State is required'),
  zip: Yup.string().required('Zip code is required'),
  authorized: Yup.boolean().oneOf([true], 'You must authorize the payment')
});

export const validatePreAuthModal = async (formik) => {
  const errors = await formik.validateForm();
  if (errors && Object.keys(errors).length > 0) {
    formik.setTouched(
      Object.keys(errors).reduce((touched, field) => {
        touched[field] = true;
        return touched;
      }, {})
    );
    return false;
  }
  return true;
};
